/**
 * Add a button to the event category menu for each event category slider found on any given page
 */
export default class EventCategoryMenu {
    constructor($el) {
        this.$el = $el;
        this.$eventCategorySliders = document.querySelectorAll('[data-event-slider]');
        this.$ticketButton = document.querySelector('[data-sticky-ticket-button]');

        this.$list = this.$el.querySelector('[data-event-category-menu-list]');
        this.menuButtonsByTarget = new Map();

        this.createButton = this.createButton.bind(this);
        this.createTicketButton = this.createTicketButton.bind(this);
        this.toggleTicketButton = this.toggleTicketButton.bind(this);
        this.handleHashChange = this.handleHashChange.bind(this);
        this.handleSliderIntersect = this.handleSliderIntersect.bind(this);

        this.$eventCategorySliders.forEach($slider => {
            this.createButton($slider);
        });

        this.hideMenuUntilTicketButtonVisible = ! this.$eventCategorySliders.length && this.$ticketButton;

        if (this.$ticketButton) {
            this.createTicketButton();
        }

        if ( ! this.$eventCategorySliders.length && ! this.$ticketButton) {
            this.$el.classList.add('no-display');
        } else if (this.hideMenuUntilTicketButtonVisible && ! this.$ticketMenuItem.classList.contains('is-visible')) {
            this.$el.classList.add('no-display');
        }

        if (this.$eventCategorySliders.length) {
            this.initActiveMenuItem();
        }
    }

    /**
     * createButton
     *
     * @param $element
     */
    createButton($element) {
        if ( ! $element.dataset.eventSlider) {
            return;
        }

        const li = document.createElement('li');

        const button = document.createElement('a');
        button.href = `#${$element.dataset.eventSlider}`;
        button.textContent = $element.dataset.eventSliderLabel;
        button.classList.add('button');
        button.classList.add('button--small');
        button.addEventListener('click', () => {
            this.setActiveMenuItem($element.dataset.eventSlider);
        });

        li.append(button);
        this.$list.append(li);

        this.menuButtonsByTarget.set($element.dataset.eventSlider, button);
    }

    initActiveMenuItem() {
        this.handleHashChange();

        if (!this.activeTarget) {
            this.setActiveMenuItem(this.$eventCategorySliders[0].dataset.eventSlider);
        }

        window.addEventListener('hashchange', this.handleHashChange);

        if (!('IntersectionObserver' in window)) {
            return;
        }

        this.sliderObserver = new IntersectionObserver(this.handleSliderIntersect, {
            threshold: 0.25,
            rootMargin: '-20% 0px -55% 0px',
        });

        this.$eventCategorySliders.forEach($slider => {
            this.sliderObserver.observe($slider);
        });
    }

    handleHashChange() {
        if (!window.location.hash) {
            return;
        }

        this.setActiveMenuItem(window.location.hash.slice(1));
    }

    handleSliderIntersect(entries) {
        const visibleEntry = entries
            .filter(entry => entry.isIntersecting)
            .sort((entryA, entryB) => Math.abs(entryA.boundingClientRect.top) - Math.abs(entryB.boundingClientRect.top))[0];

        if (!visibleEntry) {
            return;
        }

        this.setActiveMenuItem(visibleEntry.target.dataset.eventSlider);
    }

    setActiveMenuItem(target) {
        const activeButton = this.menuButtonsByTarget.get(target);

        if (!activeButton || this.activeTarget === target) {
            return;
        }

        this.menuButtonsByTarget.forEach($button => {
            $button.classList.toggle('button--active', $button === activeButton);
        });

        this.activeTarget = target;
    }

    createTicketButton() {
        const li = document.createElement('li');
        li.classList.add('event-category-menu__ticket-button');

        const button = this.$ticketButton.cloneNode(true);
        button.classList.remove('button--full-width');
        button.classList.remove('m-t-16');
        button.classList.add('button--small');
        button.removeAttribute('data-sticky-ticket-button');

        li.append(button);
        this.$list.append(li);

        this.$ticketMenuItem = li;

        if (!('IntersectionObserver' in window)) {
            this.$ticketMenuItem.classList.add('is-visible');
            return;
        }

        this.ticketObserver = new IntersectionObserver(([entry]) => {
            this.toggleTicketButton(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });

        this.ticketObserver.observe(this.$ticketButton);
    }

    toggleTicketButton(show) {
        this.$ticketMenuItem.classList.toggle('is-visible', show);

        if (this.hideMenuUntilTicketButtonVisible) {
            this.$el.classList.toggle('no-display', ! show);
        }
    }
}
